import { Images } from 'assets/images';
import { ROUTES } from 'utils/routeNames';

export const NAV_ITEMS_LOGINED = [
  { key: 'About Us', icon: Images.aboutUs, title: 'About Us', path: '/' },
  { key: 'Contact Us', icon: Images.contactUs, title: 'Contact Us', path: '/' },
  // { key: 'Tours', icon: Images.toursIcon, title: 'Tours', path: '/' },
  { key: 'Eng', icon: Images.langGuage, title: 'Eng', path: 'Eng' },
];

export const GENDERS = {
  female: 'female',
  male: 'male',
  custom: 'custom',
};

export const REQUESTS = [
  {
    name: 'Request 1',
    submitted: '21/April/2022',
    status: 'Requested',
  },
  {
    name: 'Request 2',
    submitted: '22/April/2022',
    received: '28/April/2022',
    status: 'Available',
  },
  {
    name: 'Request 1',
    submitted: '21/April/2022',
    status: 'Requested',
  },
  {
    name: 'Request 2',
    submitted: '22/April/2022',
    received: '28/April/2022',
    status: 'Available',
  },
  {
    name: 'Request 1',
    submitted: '21/April/2022',
    status: 'Requested',
  },
  {
    name: 'Request 2',
    submitted: '22/April/2022',
    received: '28/April/2022',
    status: 'Available',
  },
  {
    name: 'Request 1',
    submitted: '21/April/2022',
    status: 'Requested',
  },
  {
    name: 'Request 2',
    submitted: '22/April/2022',
    received: '28/April/2022',
    status: 'Available',
  },
  {
    name: 'Request 1',
    submitted: '21/April/2022',
    status: 'Requested',
  },
  {
    name: 'Request 2',
    submitted: '22/April/2022',
    received: '28/April/2022',
    status: 'Available',
  },
  {
    name: 'Request 1',
    submitted: '21/April/2022',
    status: 'Requested',
  },
  {
    name: 'Request 2',
    submitted: '22/April/2022',
    received: '28/April/2022',
    status: 'Available',
  },
  {
    name: 'Request 1',
    submitted: '22/April/2022',
    status: 'Requested',
  },
  {
    name: 'Request 1',
    submitted: '21/April/2022',
    status: 'Requested',
  },
  {
    name: 'Request 2',
    submitted: '22/April/2022',
    received: '28/April/2022',
    status: 'Available',
  },
  {
    name: 'Request 1',
    submitted: '22/April/2022',
    status: 'Requested',
  },
];

export const REQUEST_COMPONENT_SWITCHER = {
  home: 'home',
  start: 'start',
  request: 'request',
};

export const SettingsCategoryProfile = 'Profile Settings';
export const SettingsCategoryPassword = 'Password';
export const SettingsCategoryEmail = 'Email Address';
export const SettingsCategoryDeleteAccount = 'Delete Account';
export const RELEASE_DATE = '12 Dec 2022 15:00:00';
export const OFFICE_ADDRESS = '24/17 Azatutyan Ave, Yerevan, Armenia';
export const EMAIL_ADDRESS = 'info@itah.com';
export const INPUT_PASSWORD_TYPE = 'password';
export const INPUT_TEXT_TYPE = 'text';
export const REQUESTED = 'Requested';
export const AVAILABLE = 'Available';
export const REQUEST_INFO = 'requestInfo';
export const OLD_PASSWORD = 'old_password';
export const PASSWORD = 'password';
export const PASSWORD_CONFIRMATION = 'password_confirmation';
export const RequestsBlokType = 'Requests Blok';
export const RequestsQuestionsType = 'Requests Questions';
export const GREEN_BACKGROUND = 'green-background';
export const RequestsOfferType = 'Requests Offer';

export const LINKS = {
  FACEBOOK: 'https://www.facebook.com/profile.php?id=100087167431028',
  INSTAGRAM: 'https://www.instagram.com/itah.ai/',
  TWITTER: 'https://twitter.com/itah_ai',
  TELEGRAM: '',
  LINKEDIN: 'https://www.linkedin.com/company/itah/',
};

export const hoverSettings = {
  password: 'Password',
  deleteAccount: 'Delete Account',
};

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const RequestStartText = `Please take a few minutes to fill out Itah’s short questionnaire
 so we can generate the best packages based on your budget and individual interests.`;

export const slidesConfig = [
  {
    id: '1',
    img: Images.slide1,
    info: {
      name: 'Anton k.',
      country: 'Yerevan, Armenia',
      comment:
        '“We had an amazing vacation. We traveled from Armenia ' +
        'to Greece and then Cyprus. From start to finish the entire trip ' +
        'went smoothly. Hotels in Santorini and Mykonos were amazing, as ' +
        'was their hotel in Cyprus. Transfers to/from airports, hotels, and ferry were perfect!”',
    },
  },
  {
    id: '2',
    img: Images.slide2,
    info: {
      name: 'Anastasia a.',
      country: 'Yerevan, Armenia',
      comment: `“I want to thank everyone involved for the most awesome vacation! The food, the culture, 
      the history, the art, the architecture...everything was amazing and so seamless. All of the transportation,
       the activities, the guides, the hotels and their staff—so friendly and helpful. As you can tell,
        we all had an amazing time. I am bragging about you and your company and the services you provide!”`,
    },
  },
  {
    id: '3',
    img: Images.slide3,
    info: {
      name: 'Mariam gh.',
      country: 'Tbilisi, Georgia',
      comment:
        '“If you are a travel assistant and have not no idea where to go, you' +
        ' should definitely try this platform. Fantastic service and my friends are' +
        ' so excited for their trip to Malta in the Fall with amazing hotels and tours.' +
        ' Thank you for making our job easier.”',
    },
  },
  {
    id: '4',
    img: Images.slide4,
    info: {
      name: 'Amy A.',
      country: 'York, United Kingdom',
      comment:
        '“A very emotional experience. Thank you for leading this successful trip. The hotel, the food, the guide and the traveling and trip schedule including visiting significant places in Bahrain made this trip an experience which was perfectly orchestrated and adjusted according to limits and changes. Thank you for all your efforts.”',
    },
  },
  {
    id: '5',
    img: Images.slide5,
    info: {
      name: 'Tigran k.',
      country: 'Yerevan, Armenia',
      comment:
        '“Itah makes me look so good because you can do it all for me. ' +
        'I like your package suggestions, all the day tours you offer, your ' +
        'pleasant and skilled agents, and your customer service.”',
    },
  },
  {
    id: '6',
    img: Images.slide6,
    info: {
      name: 'Anita K.',
      country: 'Yerevan, Armenia',
      comment: `“Planning process was excellent with quick response times, amazing suggestions and a
       tailored experience that was perfect for my group of 6. This platform ended up giving us an experience of
        a lifetime and there were very few aspects of the trip we would change.”`,
    },
  },
];

export const PASSWORD_COMPONENT_ID = 'password-edit';
export const DELETE_ACCOUNT_ID = 'delete-account';
export const ACTIVE_CLASS = 'active';
export const PASSWORD_TEXT = 'Password';
export const DELETE_ACCOUNT_TEXT = 'Delete Account';

export const WARNING_MESSAGE_REQUEST =
  'Please, fill out your Personal Information to send a request.';

export const MAXIMUM_KB_USER_PUT = '3000000';

export const ITAH_ADMIN_LISTS = [
  {
    main_image: Images.userGroup,
    name: 'Users',
    route: ROUTES.ADMIN_HOME,
  },
  {
    main_image: Images.questionGroup,
    name: 'Questions',
    route: ROUTES.ADMIN_QUESTIONS,
  },
  {
    main_image: Images.packageGroup,
    name: 'Package',
    route: ROUTES.ADMIN_PACKAGES,
  },
  {
    main_image: Images.requestGroup,
    name: 'Requests',
    route: ROUTES.ADMIN_REQUESTS,
  },
  {
    main_image: Images.suggestionGroup,
    name: 'Suggestions',
  },
  {
    main_image: Images.hotOfferGroup,
    name: 'Hot Offers',
    route: ROUTES.ADMIN_HOT_OFFERS,
  },
];
